import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import styles from "./side-bar-control.module.css"

export const SidebarControl = ({ className, onHandleArrow, arrowLeft }: { 
    className?: string 
    onHandleArrow: () => void
    arrowLeft: boolean
}) => {

    return (
        <div className={`${!arrowLeft?styles.hidden:""} ${styles.sidebarControl} ${className}`} onClick={onHandleArrow}>
            <FontAwesomeIcon className={!arrowLeft ? styles.arrowLeft : styles.arrowRight} icon={faChevronLeft} /> 
        </div>
    )

}
